module.exports = __webpack_public_path__ + "img/未标题-3-07.5afbb6d3.png";